export const contents = ["Stranger Things","My Name", "Squid Game", "House Of Cards", "You", "Sex Education","D.P.","The Queen's Gambit", "Bridgerton"]


export const scorelist = 
{80: "Wow! 이정도면 넷플릭스 덕후로 인정!😀",
  50: "아직 갈 길이 멀군요! 좀 더 많은 작품을 보고 와주세요!",
  30: "아직 넷플릭스 어린이군요?! 이제 함께 더 많은 재미를 알아가보아요",
  0: "아직 넷플릭스 오리지널을 못 보셨군요?! 이제 정주행 달리시죠!"
};

export const scorelistEng =
{80: "Wow! You're the Netflix Master! 😀",
 50: "You have a long way to go! You should watch more shows!!",
 30: "You are netflix Newbie! 😐",
 0: "Oh- Don't give up! Turn on The Netflix!"
};